module.exports = __webpack_public_path__ + "img/麻黄根.80da580b.jpg";